<template>
	<li
		class="page-item"
		:class="{ disabled: !!disabled, active: !!active, [classType]: !!classType }"
		:aria-current="!!active ? 'page' : null"
	>
		<span class="page-link" :aria-label="label" v-if="!!disabled || !!active">
			<font-awesome-icon :icon="icon" v-if="!!icon"></font-awesome-icon>
			{{ text }}
			<span class="sr-only" v-if="!!active">(current)</span>
		</span>
		<button class="page-link" @click="onClick" v-else>
			<font-awesome-icon v-if="!!icon" :icon="icon"></font-awesome-icon>
			{{ text }}
		</button>
	</li>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		active: {
			type: Boolean,
			default: false,
			required: false,
		},
		icon: {
			type: Array,
			default: null,
			required: false,
		},
		label: {
			type: String,
			default: null,
			required: false,
		},
		text: {
			type: Number,
			default: null,
			required: false,
		},
		page: {
			type: Number,
			default: 1,
			required: true,
		},
		classType: {
			type: String,
			default: '',
			required: false,
		},
	},
	methods: {
		onClick: function() {
			this.$parent.toPage(this.page)
		},
	},
}
</script>
